import { useConnect } from '@lore/query-connect';
import { useUser } from '@lore/auth';

export default function usePendingInvitations(props) {
  const currentUser = useUser();

  const params = {
    where: {
      eager: {
        $where: {
          userId: currentUser.id,
          response: 'Pending'
        }
      }
    },
    pagination: {
      pageSize: 100,
      order: 'createdAt desc'
    }
  };

  return useConnect('invitation.find', params);
}
